import * as React from 'react'

function SvgCommentCheckedIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
        fill="#2EC40B"
      />
      <path
        d="M20 11c0-.338.019-.672.055-1H16.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C10 13.04 10 14.16 10 16.4v12.186c0 .89 1.077 1.337 1.707.707l3.298-3.299c.412.006.873.006 1.395.006h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.413-.81.435-1.858.436-3.87a9.096 9.096 0 0 1-2 0c0 .96-.006 1.61-.048 2.118-.044.544-.12.745-.17.844a2 2 0 0 1-.874.874c-.099.05-.3.126-.844.17-.566.046-1.31.048-2.464.048h-7.2c-.526 0-.973 0-1.368-.005l-.844-.012L12 26.172V16.4c0-1.153.002-1.898.048-2.464.044-.544.12-.745.17-.844a2 2 0 0 1 .874-.874c.099-.05.3-.126.844-.17.566-.046 1.31-.048 2.464-.048h3.655A9.098 9.098 0 0 1 20 11Z"
        fill="#000"
      />
      <path
        d="M25.996 19.486a8.971 8.971 0 0 1-1.99-.998c-.006.08-.006.181-.006.312v.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218.586.586 0 0 0 .051-.24ZM21.515 16a8.968 8.968 0 0 1-1.003-2H14.8c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C14 14.38 14 14.52 14 14.8v.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h6.715ZM14 18.8c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C14.38 18 14.52 18 14.8 18h6.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C21.62 20 21.48 20 21.2 20h-6.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C14 19.62 14 19.48 14 19.2v-.4Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgCommentCheckedIcon
